import { createFileRoute } from '@tanstack/react-router'
import UmbrellaHomeV2 from '@/components/umbrella/UmbrellaHomeV2'

export const Route = createFileRoute('/home-v2')({
  component: UmbrellaHomeV2,
})
